import {useCallback} from 'react'

import {useRouterContext} from './RouterContext'

export const useHistory = () => {
  const [, dispatch] = useRouterContext()
  const push = useCallback((payload: string) => dispatch({type: 'push', payload}), [dispatch])
  const replace = useCallback((payload: string) => dispatch({type: 'replace', payload}), [dispatch])

  return {
    push,
    replace,
  }
}

export const useParams = () => {
  const [tab, id] = useRouterContext()[0]

  return {
    tab,
    id,
  }
}
